import React from 'react';
import UnifiedForgotPassword from '@components/UnifiedForgotPassword';

const ForgotPassword: React.FC = () => {
  return <UnifiedForgotPassword theme="light" />;
};

export default ForgotPassword;
